



























import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import isMobile from 'ismobilejs'

@Component({
  components: {
    VideoCallMainScreen: () => import('./VideoCallMainScreen.vue'),
    VideoCallDeviceSettingTool: () => import('./VideoCallDeviceSettingTool.vue')
  }
})
export default class VideoCallMainScreenContainer extends Vue {
  $store!: ExStore

  get microphoneActive() {
    return this.$store.getters['videoCallRoom/microphoneActive']
  }

  get videoActive() {
    return this.$store.getters['videoCallRoom/videoActive']
  }

  get isAndroid() {
    console.log(isMobile(window.navigator))
    return isMobile(window.navigator).android.device
  }

  handleClickMuteAudio() {
    this.$store.commit('videoCallRoom/microphoneActive', !this.microphoneActive)
  }

  handleClickMuteVideo() {
    this.$store.commit('videoCallRoom/videoActive', !this.videoActive)
  }

  handleListSubScreen() {
    this.$emit('listSubScreen')
  }

  handleClickHangUpButton() {
    this.$emit('hangup')
  }
}
